<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Select Template</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div mat-dialog-content style="height: calc(100% - 95px); max-height: 100%">
    <div fxLayout="column" fxFlexFill fxLayoutGap="5px" *ngIf="!selectedTemplate">
      <app-grid-filter placeholder="Type '/' to bring up a list of available filters, or type any text to search"
                       [disableUrlChanges]="true"
                       [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
      </app-grid-filter>
      <div fxFlex="auto" fxFlexFill class="stretched-container">
        <app-pro-messaging-whats-app-templates-grid [filterChangeEvent]="filterChangeEvent"
                                                    [showSelection]="true"
                                                    (onRowSelected)="onTemplateSelected($event)">
        </app-pro-messaging-whats-app-templates-grid>
      </div>
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxFlexFill fxLayoutGap="10px" *ngIf="selectedTemplate">
      <mat-card appearance="outlined" fxFlex>
        <mat-card-title>{{selectedTemplate.name}} - {{selectedTemplate.language | language}}</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap="10px">
          <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">

            <div fxLayout="column" fxLayoutGap="10px" *ngIf="headerAttachmentForm">
              <mat-label class="label-text">Header Attachment ({{headerAttachmentForm.name}})</mat-label>
              <app-template-upload-input #fileInput
                                         [name]="headerAttachmentForm.name"
                                         [mimeTypes]="headerAttachmentForm.mimeTypes"
                                         (validationError)="onFileValidationError($event)"
                                         (valueChanged)="onFileChanged($event)"
              ></app-template-upload-input>
            </div>

            <div fxLayout="column" fxLayoutGap="10px" *ngIf="headerForm">
              <app-mat-text-input label="Header param 1"
                                  [name]="headerForm.name"
                                  [formControl]="getFormControl(headerForm.name)"
              ></app-mat-text-input>
            </div>

            <div fxLayout="column" fxLayoutGap="10px">
              <app-mat-text-input *ngFor="let item of bodyForm" [required]="true"
                                  label="Body param {{item.index}}"
                                  [name]="item.name"
                                  [formControl]="getFormControl(item.name)"
              ></app-mat-text-input>
            </div>

            <div fxLayout="column" fxLayoutGap="10px">
              <app-mat-text-input *ngFor="let item of buttonsForm" [required]="true"
                                  label="Button param {{item.index}}"
                                  [name]="item.name"
                                  [formControl]="getFormControl(item.name)"
              ></app-mat-text-input>
            </div>
          </form>

        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" fxFlex="30" fxFlex.xs="" class="message-preview-holder">
        <mat-card-title>Preview Message</mat-card-title>
        <mat-card-content>
          <div class="message-item-content" fxLayout="column" fxLayoutGap="10px">
            <span *ngIf="templateHeaderObj && templateHeaderObj.text"><b>{{previewHeader()}}</b></span>
            <!--<div *ngFor="let media of imagesList">
              <a [href]="media.url" target="_blank">
                <img class="image-preview" [src]="media.url" [alt]="media.displayName"/>
              </a>
            </div>
            <div *ngFor="let media of videoList">
              <a [href]="media.url" target="_blank">
                <video controls class="image-preview" [src]="media.url"></video>
              </a>
            </div>
            <div *ngFor="let media of audioList">
              <a [href]="media.url" target="_blank">
                <audio controls class="image-preview" [src]="media.url"></audio>
              </a>
            </div>
            <div *ngFor="let media of otherList">
              <a [href]="media.url" target="_blank" style="display: block">
                {{media.displayName}}
              </a>
            </div>-->
            <div style="overflow: hidden;" *ngIf="templateBodyObj">
            <span style="white-space: pre-line; text-align: left; display: inline-block; max-width: 100%;"
                  [innerHTML]="previewBody()"></span>
            </div>
            <span *ngIf="templateFooterObj && templateFooterObj.text"
                  style="padding-top: 10px"><i>{{templateFooterObj.text}}</i></span>
            <div *ngIf="templateButtonsObj" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="5px">
              <button type="button" mat-flat-button *ngFor="let item of templateButtonsObj.buttons"
                      [matTooltip]="item.url || item.phone_number">{{item.text}}</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
  <div mat-dialog-actions style="justify-content: flex-end;">
    <button mat-stroked-button (click)="backToList()" *ngIf="selectedTemplate">Back</button>
    <button mat-flat-button color="primary" (click)="sendTemplate()" *ngIf="selectedTemplate"
            [disabled]="this.form && this.form.invalid">Send
    </button>
    <button mat-stroked-button [mat-dialog-close]="false" cdkFocusInitial>Close</button>
  </div>
</div>
